"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badges = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var Badges = function (props) {
    var children = props.children, className = props.className, id = props.id;
    return (react_1.default.createElement(Wrapper, { id: id, className: (0, classnames_1.default)('man-ui badges', className) }, children));
};
exports.Badges = Badges;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n\n  > * {\n    margin-left: 15px;\n\n    &:first-child {\n      margin-left: 5px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n\n  > * {\n    margin-left: 15px;\n\n    &:first-child {\n      margin-left: 5px;\n    }\n  }\n"])));
exports.default = exports.Badges;
var templateObject_1;
